import { Component, Inject, OnDestroy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { UserService } from "@shared/services/user.service";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-email-confirmation",
  templateUrl: "./email-confirmation.component.html",
  styleUrls: ["./email-confirmation.component.scss"],
})
export class EmailConfirmationComponent implements OnDestroy {
  /** Emits when the component is destroyed, used to complete all active subscriptions */
  private onDestroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { email: string },
    private dialogRef: MatDialogRef<EmailConfirmationComponent>,
    private translateService: TranslateService,
    private router: Router,
    public snackBar: MatSnackBar,
    private userService: UserService
  ) {}

  /**
   * Cleans up subscriptions and subjects when the component is destroyed.
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  /**
   * Closes the dialog and navigates to landing page
   */
  public close(): void {
    this.dialogRef.close(true);
    this.router.navigate(["/landing"]);
  }

  /**
   * Resends the email verification link
   */
  public resend(): void {
    this.userService
      .resendVerify(this.data.email)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: () => {
          this.snackBar.open(`✅ ${this.translateService.instant("page.registration.resend.msg")}`, "OK", { duration: 5000 });
        },
        error: () => {
          this.snackBar.open(`❗ ${this.translateService.instant("common.error")}`, "OK", {
            duration: 5000,
          });
        },
      });
  }
}
